import qs from 'qs'

export const GET_INDIVIDUAL_POINTS_STATEMENT_PENDING = 'GET_INDIVIDUAL_POINTS_STATEMENT_PENDING';
export const GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_PENDING = 'GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_PENDING';
export const GET_INDIVIDUAL_POINTS_STATEMENT_FULFILLED = 'GET_INDIVIDUAL_POINTS_STATEMENT_FULFILLED';
export const GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_FULFILLED = 'GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_FULFILLED';
export const GET_INDIVIDUAL_POINTS_STATEMENT_REJECTED = 'GET_INDIVIDUAL_POINTS_STATEMENT_REJECTED';
export const GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_REJECTED = 'GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_REJECTED';

export default function pointsStatementReducer(state = {
	personalList: [],
  personalListPaging: {
    number: 1,
    size: 10
  },
	staffList: [],
  staffListPaging: {
    number: 1,
    size: 10
  },
  fetching: false,
  fetched: false,
  outlets: [],
  outletsFetching: false,
  outletsFetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case GET_INDIVIDUAL_POINTS_STATEMENT_PENDING: {
      return {
        ...state,
        fetching: true,
        fetch: false
      }
    }
    case GET_INDIVIDUAL_POINTS_STATEMENT_FULFILLED: {
	      const lastPage = action.payLoad.links.last;
	      let page = state.personalListPaging;
	      if (lastPage) {
	        page = qs.parse(lastPage.split('?')[1]).page;
	      }

      return {
        ...state,
        fetching: false,
        fetched: true,
        personalList: action.payLoad.data,
        personalListPaging: page
      }
    }
    case GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_REJECTED:
    case GET_INDIVIDUAL_POINTS_STATEMENT_REJECTED: {
      return {
        ...state,
        errors: action.payLoad
      }
    }
    case GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_PENDING: {
      return {
        ...state,
        outletsFetched: false,
        outletsFetching: true,
      };
    }
    case GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_FULFILLED: {
      return {
        ...state,
        outletsFetched: true,
        outletsFetching: false,
        outlets: action.payLoad.data,
      }
    }
		default: {
			return {...state};
		}
	}
}



// WEBPACK FOOTER //
// ./src/reducers/pointsStatementReducer.js